var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIconBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2505 25.1457C14.8396 25.2907 14.163 25.2907 13.7521 25.1457C10.248 23.9494 2.41797 18.959 2.41797 10.5007C2.41797 6.76693 5.42672 3.74609 9.1363 3.74609C11.3355 3.74609 13.2809 4.80943 14.5013 6.45276C15.7217 4.80943 17.6792 3.74609 19.8663 3.74609C23.5759 3.74609 26.5846 6.76693 26.5846 10.5007C26.5846 18.959 18.7546 23.9494 15.2505 25.1457Z",
    stroke: "#1B2831",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconBig);
export default __webpack_public_path__ + "static/media/heartIconBig.6e194981302a599972325c94a02c04c7.svg";
export { ForwardRef as ReactComponent };